import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationDE from './locales/de.json';
import translationEN from './locales/en.json';
import translationFR from './locales/fr.json';
import translationIT from './locales/it.json';

const resources = {
  de: {
    translation: translationDE
  },
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  it: {
    translation: translationIT
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de', // Fallback auf Deutsch
    lng: 'de', // Standard: Deutsch (Schweiz)
    interpolation: {
      escapeValue: false // React already escapes
    },
    detection: {
      // Reihenfolge der Spracherkennung
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Welche Caches verwendet werden
      caches: ['localStorage'],
      // localStorage key
      lookupLocalStorage: 'i18nextLng'
    },
    // Debug mode (in production auf false setzen)
    debug: false,
    // Namespace
    ns: ['translation'],
    defaultNS: 'translation'
  });

export default i18n;